<!--
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-23 08:20:39
-->
<template>
    <div class="majorproduct-container">
  
      <div class="submenu-wrapper">
        <Submenu 
        :engLabel="englabel"
        :cnLabel="cnLabel"
        :linkData="linkData"
      />
      </div>
  
      <div class="main-wrapper py-2 py-md-5 px-2">


          <!-- 晋升路线图-->
          <div class="img-wrapper">
          <p class="split-header">晋升路线图</p>
          <div class="row justify-content-center">
            <div class="col-12 col-xl-10">

             <ImageLoader 
                :src="img"
                :height="imgHeight"
                fit="fill"
                />
                
            </div> 
         </div>
        </div>


          <!-- 晋升路线 -->
          <div class="img-wrapper">
          <p class="split-header">晋升路线</p>
          <div class="row justify-content-center">
            <div class="col-12 col-xl-10">

                  <div>
                     <h4>研发1类: </h4>
                     <p>（软件、硬件、机械、测试、项目、研发质量）分6个级别：助理工程师→初级工程师→中级工程师→高级工程师→资深工程师→专家级工程师/顾问。</p>
                  </div>
                  <div>
                    <h4>研发2类: </h4>
                    <p>（功能安全、试验）分4个级别：其中功能安全分为中级工程师→高级工程师→资深工程师→家级工程师/顾问，试验分为助理工程师，初级工程师，中级工程师，高级工程师。</p>
                  </div>
                  <div>
                    <h4>生产技术类: </h4>
                     <p>（生产质量、生产技术、生产工艺）分4个级别：助理工程师→初级工程师→中级工程师→高级工程师。</p>
                  </div>
                  <div>
                    <h4>其他管理类: </h4>
                    <p>（财务、行政、人力资源、市场营销、体系、采购）分4个级别：初级（会计/专员/客户经理/工程师）→中级（会计/专员/客户经理/工程师）→高级（会计/专员/客户经理/工程师）→资深（会计/专员/客户经理/工程师）。</p>
                  </div>
                
            </div> 
         </div>
        </div>

      </div>


    </div>
  </template>
  
  <script>
  import { JobsLink } from "@/assets/js/submenulink.js";
  import { getProductDetails } from "@/api/product.js";
  import Submenu from "@/components/Submenu/";
  import ImageLoader from "@/components/ImageLoader/";
  import ImagePreview from "@/components/ImagePreview";

  export default {
     components: {
      Submenu,
      ImageLoader,
      ImagePreview,
     },
    
     data() {
      return {
        englabel: 'Jobs',
        cnLabel: '人才战略',
        imgHeight: 732,
        img_aspect_ratio: (1351 / 732).toFixed(2),
        ProductData:[],//产品数据
        windowSize: {},
        linkData: [],
        img: require("@/assets/img/Jobs/jobs3.png"),

      }
    },
  
    created() {
        this.getWindowSize();
        this.linkData = JobsLink;
        this.getProductData();
     },
  

    mounted() {
        //拉伸窗口时触发
        window.onresize = () => {
            this.getWindowSize();
            
        }
  
    },
     methods: {
      getProductData() {
        getProductDetails().then(res => {
              this.ProductData = res;
            });
        },

      getWindowSize() {
           this.windowSize.width =   document.documentElement.clientWidth || document.body.clientWidth; 
           this.windowSize.Height =  document.documentElement.clientHeight || document.body.clientHeight; 
           this.imgHeight = Math.round(this.windowSize.width / this.img_aspect_ratio); 
        },
        getPreviewurl(item){
         return [item];
       },
     }
  
  
  }
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/global.less";
  @import "~@/styles/mixin.less";
    .majorproduct-container{
      position: relative;;
      width: 100%;;
      height: auto;
      .general-layout;
  
        .product-details{
          margin:3rem 1rem;
          .product-title{
            text-align: center;
            font-weight: bold;
            margin-bottom: 1rem;
          }

          .product-img{
            width: 100%;
            text-align: center;
            .image-preview-container{
                display: inline-block;
            }
          }

          .details-text span{
            font-weight: 700;
          }
        }
  
    }
  
  </style>